import React = require("react");
import * as dateMath from 'date-arithmetic';
import { DateInput } from "./DateInput";
import { Icon } from "../icons/Icons";
import { colors } from "../colors/color";
import { Flex } from "../compositeComponents/FlexHelpers";



type StartEndDateFieldsProps = {
    start:Date,
    end:Date,
    noBorder?:boolean,
    disabled?:boolean,
    onChanged:(start:Date, end:Date)=>void
}
export function StartEndDateFields(props:StartEndDateFieldsProps): JSX.Element {

    function handleStartChange(value:Date){
        const {start,end} = maybeAdjustEnd(props.start, value, props.end);
        props.onChanged(start,end);
    }

    function handleEndChange(value:Date|null){
        const {start,end} = maybeAdjustStart(props.start, props.end, value);
        props.onChanged(start,end);
    }

    const adjustedStart = new Date(props.start.getFullYear(), props.start.getMonth(), props.start.getDate());
    const adjustedEnd = new Date(props.end.getFullYear(), props.end.getMonth(), props.end.getDate());

    return (
        <Flex gap={8} justifyContent="flex-start" alignItems="center" flexWrap="wrap">
            <div style={{ flexShrink: 0 }}>
                <DateInput
                    noBorder={props.noBorder}
                    value={adjustedStart}
                    onValueChange={handleStartChange}
                    disabled={props.disabled} />
            </div>

            <div>
                <Icon name="arrows_arrow_arrowForward" color={colors.text.normal} />
            </div>
            
            <div style={{ flexShrink: 0 }}>
                <DateInput
                    noBorder={props.noBorder}
                    value={adjustedEnd} 
                    onValueChange={handleEndChange}
                    disabled={props.disabled} />
            </div>
        </Flex>
    );
}

function maybeAdjustEnd(oldStart:Date, newStart:Date, end:Date):{ start:Date, end:Date }
{
    let newEnd = end;
    if(newStart >= end){
        const diff = dateMath.diff(oldStart, end, 'milliseconds');
        newEnd = dateMath.add(newStart, diff, 'milliseconds');
    }
    return {start:newStart, end:newEnd};
}

function maybeAdjustStart(start:Date, oldEnd:Date, newEnd:Date):{ start:Date, end:Date }
{
    let newStart = start;
    if(newEnd <= start){
        const diff = dateMath.diff(start, oldEnd, 'milliseconds');
        newStart = dateMath.add(newEnd, -diff, 'milliseconds');
    }
    return {start:newStart, end:newEnd};
}


